


























































import { Vue, Component } from 'vue-property-decorator';
import * as api from '@/api';

import CategoryTree from '@/views/cti/components/category-tree.vue';
/**
 * 美维工单 迁移页面
 *
 * @author liyuyao
 * @date 07/09/2019
 */

const defaultCti = {
    categoryName: '',
    categoryId: 0,
    typeName: '',
    typeId: 0,
    itemName: '',
    itemId: 0
};

@Component({
    components: {
        CategoryTree
    }
})
export default class CtiTransferIndex extends Vue {
    categoryTreeList: any = [];
    totalCategoryTreeList: any = [];

    activeStep: number = 0;

    sourceCti: CommonTypes.CtiItem[] = [];

    targetCti: CommonTypes.CtiItem = defaultCti;

    transferWithCti: boolean = false;

    btnLoading: boolean = false;
    percentage: number = 0;
    migrateId: number = 0;
    interval: any;

    get btnDisabled() {
        return !(this.sourceCti.length > 0 && this.targetCti.categoryId);
    }
    mounted() {
        this.getCategoryTree();
        this.getCategoryTreeTotal();
    }
    async getCategoryTree() {
        try {
            const res = await api.ctiApi.getCategoryTree();
            this.categoryTreeList = res.data.items;
        } catch (e) {
            console.log(e);
        }
    }
    async getCategoryTreeTotal() {
        try {
            const res = await api.ctiApi.getCategoryTreeTotal(true);
            this.totalCategoryTreeList = res.data.items;
        } catch (e) {
            console.log(e);
        }
    }
    handleSourceCategoryChange(catalog) {
        // delete catalog.rgId;
        // catalog.itemName = catalog.itemName && catalog.itemName.split('（')[0];
        this.sourceCti = catalog;
    }
    handleTargetCategoryChange(catalog) {
        delete catalog.rgId;
        this.targetCti = catalog;
    }
    cancelBack() {
        this.$router
            .push({
                name: 'cti'
            })
            .catch(e => e);
    }
    async ctiTransfer() {
        this.btnLoading = true;
        try {
            const res = await api.ctiApi.ctiTransfer({
                sources: this.sourceCti,
                target: this.targetCti,
                type: this.transferWithCti ? 1 : 2
            });
            const { code, data } = res;
            if (code === 200) {
                this.activeStep++;
                this.migrateId = data.migrateId;
                this.getTransferProgress();
                if (this.percentage === 100) {
                    return;
                } else {
                    this.interval = setInterval(this.getTransferProgress, 2000);
                }
            }
            this.btnLoading = false;
        } catch (e) {
            this.btnLoading = false;
        }
    }
    async getTransferProgress() {
        try {
            const res = await api.ctiApi.getTransferProgress(this.migrateId);
            const { code, data } = res;
            if (code === 200) {
                this.percentage = data.progress;
                if (this.percentage === 100) {
                    clearInterval(this.interval);
                }
            } else {
                clearInterval(this.interval);
            }
        } catch (e) {
            clearInterval(this.interval);
            console.log(e);
        }
    }
    goBack() {
        this.$router
            .push({
                name: 'cti'
            })
            .catch(e => e);
    }
}
